import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "reactstrap";
import MessageInput from "./MessageInput";
import { useDispatch, useSelector } from "react-redux";
import { addChat } from "store/actions/resolutionAction";
import { getSingleResolution } from "store/actions/resolutionAction";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const ChatFooter = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  let { uid } = useSelector((state) => state.auth);
  const [newMessage, setNewMessage] = useState("");
  const [chatLoader, setChatLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addChat(id, newMessage, uid));
    setNewMessage("");
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="d-flex form-container border rounded mt-3 "
    >
      <div className="d-flex align-items-center w-100 bg-white rounded position-relative">
        <MessageInput
          disabled={false}
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />

        <Button
          className={`bg-primary rounded border-0 message-send-btn py-1 px-2 mt-1`}
          type="submit"
          disabled={chatLoader || newMessage.trim() === ""}
        >
          {chatLoader ? (
            <Spinner size="sm" className="" color="white" />
          ) : (
            <i className="fas text-white fa-paper-plane"></i>
          )}
        </Button>
      </div>
    </Form>
  );
};

export default ChatFooter;
